/**
 * 将关键帧材质不透明度规范到闭区间 [0, 1]；非法或缺失输入视为 1（完全不透明）。
 *
 * @param raw - 原始值（可能来自旧工程或未知类型）
 */
export function clampMaterialOpacity(raw: unknown): number {
  if (typeof raw !== 'number' || !Number.isFinite(raw)) return 1
  if (raw <= 0) return 0
  if (raw >= 1) return 1
  return raw
}
